import userHasPermission from '@/utils/user-has-permission'
import {
  canUserAccessApiViewByMerchantStatus,
  canUserAccessApiViewByMerchantTier,
  canUserAccessApiViewByMerchantType,
} from '@/utils/api-token'

const getters = {
  size: (state) => state.app.size,
  device: (state) => state.app.device,
  visitedViews: (state) => state.tagsView.visitedViews,
  cachedViews: (state) => state.tagsView.cachedViews,
  token: (state) => state.user.token,
  email: (state) => state.user.email,
  roles: (state) => state.userProfile.roles,
  permissions: (state) => state.userProfile.permissions || [],
  permissionRoutes: (state) => state.permission.routes,
  permissionAdded: (state) => state.permission.addedRoutes,
  errorLogs: (state) => state.errorLog.logs,
  currentLang: (_, getters) => getters['translations/currentLang'],
  currentLocale: (_, getters) => getters['translations/currentLocale'],
  merchantProfile: (state) => state.profile?.data || {},
  shouldDisplayBanner: (state, getters) => {
    const listOrder = getters['order/getListForBanner'] || []

    if (listOrder.length > 0) {
      return false
    }

    const userHasPermissionApiView = userHasPermission(['generate_api_key'])

    if (!userHasPermissionApiView) {
      return false
    }

    const merchantProfile = getters['profile/profile'] || {}
    const merchantTier = getters['profile/merchantTier']
    const isMerchantOnline = getters['profile/isMerchantOnline']
    const isMerchantInStore = getters['profile/isMerchantInStore']

    return (
      canUserAccessApiViewByMerchantTier(merchantTier) &&
      canUserAccessApiViewByMerchantStatus(merchantProfile?.status) &&
      canUserAccessApiViewByMerchantType(
        {
          isMerchantOnline,
          isMerchantInStore,
        },
        merchantProfile
      )
    )
  },
}

export default getters
